import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { GigCardContextProvider } from '../gig_card_context';
import './style.scss';
class GigCardsRepeater extends PureComponent {
    componentDidMount() {
        this.props.setGigCardContainerRefGetter &&
        this.props.setGigCardContainerRefGetter(() => {
            const gigCardContainerRef = this.gigCardContainerRef,
                gigCardContainerParentRef = gigCardContainerRef.parentElement,
                gigCardContainerWidth = gigCardContainerRef.getBoundingClientRect().width,
                gigCardContainerParentWidth = gigCardContainerParentRef.getBoundingClientRect().width;

            return gigCardContainerParentWidth < gigCardContainerWidth ? gigCardContainerParentRef : gigCardContainerRef;
        });
    }

    render() {
        const { context, children, responsiveGrid } = this.props,
            classes = ['react-gig-cards-slider', 'slider-hider'];

        responsiveGrid ? classes.push('row') : classes.push('cf');

        return (
            <GigCardContextProvider value={context}>
                <div className={classes.join(' ')} ref={(ref) => this.gigCardContainerRef = ref}>
                    {children.map((child, i) => <div key={`gig_item_${i}`} className={`gig-item ${context.cardSize}`}>{child}</div>)}
                </div>
            </GigCardContextProvider>
        );
    }
}

GigCardsRepeater.propTypes = {
    context: PropTypes.object,
    children: PropTypes.array,
    responsiveGrid: PropTypes.bool,
    setGigCardContainerRefGetter: PropTypes.func
};

export default GigCardsRepeater;



// WEBPACK FOOTER //
// ./src/shared/gig_cards_repeater/index.js